import { useDimensions } from "react-native-web-hooks";

export function useWindowDimensions() {
  return useDimensions().window;
}
